(() => {
  if (window.axolotlMenuImagesInitialized) return;
  window.axolotlMenuImagesInitialized = true;
  const enhancedMenuTitles = new Set([
    'shop axolotls by color',
    'axolotl essentials',
    'about us',
    'learn'
  ]);
  const CACHE_VERSION = 'v7';
  const imageCache = new Map();
  const desktopMedia = window.matchMedia('(min-width: 750px)');

  const normalizeText = (value) => (value || '').replace(/\s+/g, ' ').trim().toLowerCase();

  function normalizeImageUrl(value, pageUrl) {
    if (!value) return '';
    const candidate = value.split(',')[0].trim().split(' ')[0];
    try { return new URL(candidate, pageUrl).href; } catch { return ''; }
  }

  function findPageImage(doc, pageUrl) {
    const selectors = [
      'main article img', 'main .banner img', 'main .image-banner img',
      'main [class*="hero"] img', 'main [class*="banner"] img',
      'main section img', 'main img'
    ];

    for (const selector of selectors) {
      for (const image of doc.querySelectorAll(selector)) {
        const width = Number(image.getAttribute('width') || 0);
        const height = Number(image.getAttribute('height') || 0);
        const alt = normalizeText(image.getAttribute('alt'));
        const className = normalizeText(image.getAttribute('class'));
        const source = image.currentSrc || image.getAttribute('src') || image.getAttribute('data-src') || image.getAttribute('srcset') || '';
        if (!source || alt.includes('logo') || className.includes('logo') || source.toLowerCase().includes('logo')) continue;
        if ((width && width < 300) || (height && height < 180)) continue;
        const normalized = normalizeImageUrl(source, pageUrl);
        if (normalized) return normalized;
      }
    }

    return normalizeImageUrl(doc.querySelector('meta[property="og:image"], meta[name="twitter:image"]')?.content || '', pageUrl);
  }

  async function getImage(url) {
    if (imageCache.has(url)) return imageCache.get(url);
    const key = `menu-image:${CACHE_VERSION}:${url}`;
    if (new URL(url, window.location.origin).origin !== window.location.origin) return '';
    try {
      const cached = sessionStorage.getItem(key);
      if (cached) {
        imageCache.set(url, cached);
        return cached;
      }
    } catch {}

    const pending = (async () => {
      try {
        const response = await fetch(url, { credentials: 'same-origin' });
        if (!response.ok) return '';
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const image = findPageImage(doc, url);
        if (image) {
          try { sessionStorage.setItem(key, image); } catch {}
        }
        return image;
      } catch { return ''; }
    })();
    imageCache.set(url, pending);
    return pending;
  }

  function normalizeImages(link, card) {
    const images = [...link.querySelectorAll('img')];
    if (!images.length) return null;
    const primary = images[0];
    images.slice(1).forEach((image) => image.remove());
    primary.classList.add('menu-card__image', 'mega-menu__link-image');
    primary.alt = '';
    primary.loading = 'lazy';
    primary.decoding = 'async';
    card?.classList.add('has-menu-card-image');
    return primary;
  }

  async function enhanceLink(link) {
    const card = link.closest('.mega-menu__column > div');
    card?.classList.remove('has-menu-card-image');
    if (normalizeImages(link, card)) return;

    const imageUrl = await getImage(link.href);
    if (!imageUrl || !link.isConnected) return;
    if (normalizeImages(link, card)) return;

    const image = document.createElement('img');
    image.className = 'menu-card__image mega-menu__link-image';
    image.src = imageUrl;
    image.alt = '';
    image.loading = 'lazy';
    image.decoding = 'async';
    link.prepend(image);
    card?.classList.add('has-menu-card-image');
  }

  function scan() {
    if (!desktopMedia.matches) return;

    document.querySelectorAll('#header-component .menu-list__list-item').forEach((item) => {
      const topLink = item.querySelector(':scope > .menu-list__trigger > .menu-list__link, :scope > .menu-list__link');
      if (!topLink || !enhancedMenuTitles.has(normalizeText(topLink.textContent))) return;
      item.classList.add('menu-cards--enhanced');
      if (item.dataset.axMenuImagesBound === 'true') {
        if (item.dataset.axMenuImagesLoaded === 'true') {
          item.querySelectorAll('.mega-menu__column > div > .mega-menu__link').forEach(enhanceLink);
        }
        return;
      }
      item.dataset.axMenuImagesBound = 'true';

      const loadMenuImages = () => {
        item.dataset.axMenuImagesLoaded = 'true';
        item.querySelectorAll('.mega-menu__column > div > .mega-menu__link').forEach(enhanceLink);
      };

      item.addEventListener('pointerenter', loadMenuImages, { passive: true });
      item.addEventListener('focusin', loadMenuImages, { passive: true });
    });
  }

  let scanScheduled = false;
  const scheduleScan = () => {
    if (scanScheduled) return;
    scanScheduled = true;
    requestAnimationFrame(() => {
      scanScheduled = false;
      scan();
    });
  };

  document.addEventListener('DOMContentLoaded', scheduleScan);
  document.addEventListener('shopify:section:load', scheduleScan);
  desktopMedia.addEventListener('change', scheduleScan);

  const headerGroup = document.querySelector('#header-group');
  if (headerGroup) {
    new MutationObserver(scheduleScan).observe(headerGroup, {
      childList: true,
      subtree: true
    });
  }

  scheduleScan();
})();

